import { httpService, storage } from '@commons';

import { CONFIG_SESSION } from '@handler/common/startSession';

import { toast } from 'react-toastify';
import { ZendeskAPI } from 'ZendeskConfig';

export const setupZendeskAuth = async (user) => {
  const currentSession = JSON.parse(storage.get(CONFIG_SESSION));
  const clienteAgrareId = currentSession?.contaAgrare?.id;

  try {
    // Construir URL com query parameters para o endpoint /{idUser}
    let url = `/zendesk/jwt/${user.id}`;
    const params = new URLSearchParams();
    
    if (clienteAgrareId) {
      params.append('clienteAgrareId', clienteAgrareId);
    }
    
    if (params.toString()) {
      url += `?${params.toString()}`;
    }

    // Enviar com body vazio já que os parâmetros estão na URL
    const zendeskDTO = await httpService.postApiManager(url, {});

    ZendeskAPI(
      'messenger',
      'loginUser',
      (callback) => {
        callback(zendeskDTO.jwt);
      },
      (error) => {
        if (error) {
          toast.error('Erro ao configurar chat');
        }
      },
    );
  } catch (error) {
    toast.error('Erro de conexão com o chat');
    console.error('Erro no setupZendeskAuth:', error);
  }
};
